export const SECCIONES = ['Rendimientos', 'Beneficios', 'Calculadora']

export const POLITICAS = [
    {
        nombre: 'Tratamiento de Datos'
    },
    {
        nombre: 'Términos y condiciones'
    },
]

export const DATOS = [
    {
        nombre: 'Carrera 7 # 24-89 Edificio'
    },
    {
        nombre: 'Colpatria Oficina 704'
    },
    {
        nombre: 'genrecia@esperazahispana.com'
    },
]

export const URLAPPUSUARIO = 'https://usuario.esperanzahispana.com.co/'